import React, { FC, PropsWithChildren, useMemo } from 'react';
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl';
import { useFactory } from '@funtech-int/rival-react';

import { useLocale } from '@/shared/hooks/useLocale';

import { useDictionary } from '../../hooks/useDictionary';

export const IntlProvider: FC<PropsWithChildren> = ({ children }) => {
    const { lang } = useLocale();
    const dictionary = useDictionary();
    const cache = useFactory(createIntlCache);
    const intl = useMemo(
        () => createIntl({ locale: lang, messages: dictionary }, cache),
        [lang, dictionary, cache]
    );

    return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
};
